import {on} from '@ngrx/store';
import * as SettingsActions from './settings.actions';
import {Mode} from './settings.model';
import {createRehydrateReducer} from '../rehydrate.reducer';
import {exitCampaign} from '../campaigns/campaign.actions';
import {unauthenticated} from '../app/app.actions';

export interface SettingsState {
    character: string | undefined;
    mode: Mode;
}

const initialState: SettingsState = {
    character: undefined,
    mode: Mode.comment
};

const _settingsReducer = createRehydrateReducer(
    'settings',
    initialState,
    on(SettingsActions.setMode, (state, {mode}) => ({
        ...state,
        mode: mode
    })),
    on(SettingsActions.selectCharacter, (state, {id}) => ({
        ...state,
        character: id
    })),
    on(SettingsActions.deselectCharacter, (state) => ({...state, character: undefined})),
    on(exitCampaign, unauthenticated, (_) => initialState),
);

export function settingsReducer(state, action) {
    return _settingsReducer(state, action);
}
